import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Router from './Router';
import { getProfile } from '../../modules/auth';

class App extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    getProfile: PropTypes.func.isRequired,
    user: PropTypes.object,
  };

  componentDidMount() {
    this.props.getProfile();
  }

  // todo fix updating of app
  // shouldComponentUpdate(nextProps) {
  //   return !(nextProps.user === this.props.user);
  // }

  render() {
    const { isLoading, user } = this.props;

    if (isLoading) {
      return null;
    }

    return <Router user={user} />;
  }
}

export default withRouter(connect(state => state.auth, { getProfile })(App));



// WEBPACK FOOTER //
// ./src/containers/App/index.js